<template>
  <v-layout align-center justify-space-between row fill-height>
    <v-flex sm1>
      <v-icon
        color="#f66"
        large
        style="font-size: 40px; cursor: pointer"
        @click="$router.push('/project-list')"
      >
        arrow_back
      </v-icon>
    </v-flex>
    <v-flex sm8>
      <h1>{{ projectDetails ? projectDetails.name : "- - - - -" }}</h1>
      <br />
      <v-layout>
        <v-flex sm2><h3>Project ID</h3></v-flex>
        <v-flex sm2><h3>Project Status</h3></v-flex>
        <v-flex sm2><h3>Project Type</h3></v-flex>
        <v-flex sm2><h3>Started at</h3></v-flex>
        <v-flex sm2><h3>Ended at</h3></v-flex>
      </v-layout>
      <v-layout class="mt-2">
        <v-flex sm2>
          <p>
            {{ projectDetails ? projectDetails.id : "- - -" }}
          </p>
        </v-flex>
        <v-flex sm2>
          <p>
            {{
              projectDetails ? projectDetails.project_status_name : "- - - - -"
            }}
          </p>
        </v-flex>
        <v-flex sm2>
          <p>
            {{
              projectDetails ? projectDetails.project_type_name : "- - - - -"
            }}
          </p>
        </v-flex>
        <v-flex sm2>
          <p>
            {{ projectDetails ? projectDetails.begin_date : "- - - - -" }}
          </p>
        </v-flex>
        <v-flex sm2>
          <p>
            {{ projectDetails ? projectDetails.end_date : "- - - - -" }}
          </p>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex sm3>
      <div class="actions" v-if="projectDetails">
        <div v-for="action in projectDetails.actions" :key="action">
          <template v-if="action === 'Preview'"></template>
          <template v-else-if="action === 'Delete'"></template>
          <template
            v-else-if="
              action === 'Respondent Analytics' || action === 'Project Summary'
            "
          ></template>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Edit'"
            @click="editItem"
          >
            {{ action }}
          </v-btn>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Pause'"
            @click="changeProjectStatusToPause"
          >
            {{ action }}
          </v-btn>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Resume'"
            @click="changeProjectStatusToLive"
          >
            {{ action }}
          </v-btn>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Schedule'"
            @click="goToLive"
          >
            {{ action }}
          </v-btn>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Live'"
            @click="goToLive"
          >
            {{ action }}
          </v-btn>
          <template v-else-if="action === 'Responses'"></template>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Change Date'"
            @click="expandDate"
          >
            {{ action }}
          </v-btn>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Complete'"
            @click="updateProjectToCompleteStatus"
          >
            {{ action }}
          </v-btn>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Add Budget'"
            @click="openAddBudgetDialog"
          >
            {{ action }}
          </v-btn>
          <v-btn
            class="w-165"
            small
            v-else-if="action === 'Response Analytics'"
            @click="responseAnalytics"
          >
            {{ action }}
          </v-btn>
          <v-btn class="w-165" small v-else>
            {{ action }}
          </v-btn>
        </div>
      </div>
    </v-flex>
    <v-dialog v-model="dialog" width="400">
      <v-card>
        <v-card-title class="title blue accent-3">Timer Dialog</v-card-title>
        <v-card-text>
          <div>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="190px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="updateData.end_date"
                  :rules="endTime"
                  label="Expand Project Ending Time *"
                  v-bind="attrs"
                  prepend-icon="event"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="updateData.end_date"
                :min="new Date().toISOString().substr(0, 10)"
                @change="save"
              ></v-date-picker>
            </v-menu>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="success" flat @click="close">close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" flat @click="updateProjectEndingTime">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addBudgetDialog" width="400" v-if="selectedProject">
      <v-card>
        <v-card-title>
          <h2>Add Budget</h2>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="noOfResponses"
              :rules="[(v) => !!v || 'No. of Responses is required']"
              label="No. of Responses*"
              required
              type="number"
            ></v-text-field>
            <v-text-field
              label="Per Survey Cost"
              readonly
              :value="
                selectedProject.total_budget_amount /
                selectedProject.number_of_response
              "
            ></v-text-field>
            <v-text-field
              label="Increased Budget"
              readonly
              :value="
                noOfResponses
                  ? (noOfResponses * selectedProject.total_budget_amount) /
                    selectedProject.number_of_response
                  : 0
              "
            ></v-text-field>
            <v-btn
              color="primary"
              :disabled="!noOfResponses"
              :loading="addBudgetLoading"
              class="mx-0"
              @click="addBudget"
            >
              Submit
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addBudgetErrorDialog"
      width="400"
      v-if="selectedProject"
      persistent
    >
      <v-card class="pa-2">
        <v-card-title>
          <h2 class="red--text">
            You don't have enough balance. Please Top UP
          </h2>
        </v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-btn class="primary" @click="$router.push('/client-payment-page')">
            Top Up
          </v-btn>
          <v-spacer />
          <v-btn class="error" @click="addBudgetErrorDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-flex sm12></v-flex> -->
    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ msg }}
    </v-snackbar>
  </v-layout>
</template>
<script>
import api from "../../api/datadash";
import { mapState } from "vuex";
import { ROOT_URL } from "@/api/connectingUrls";
import axios from "axios";
import router from "../../router";
export default {
  data() {
    return {
      snackbar: false,
      color: "success",
      msg: "Updated successfully",
      projectDetails: null,
      dialog: false,
      addBudgetDialog: false,
      addBudgetErrorDialog: false,
      updateData: {
        project_id: null,
        end_date: null,
      },
      endTime: [(v) => !!v || "Enter project ending time"],
      menu: false,
      noOfResponses: null,
      selectedProject: null,
      addBudgetLoading: false,
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  created() {
    this.fetchProjectDetails();
  },
  methods: {
    async fetchProjectDetails() {
      const { data } = await api.fetchData(
        this.auth.token,
        `project-details/${this.$route.params.id}`
      );
      this.projectDetails = data.data;
    },
    checkItem() {
      this.loading = true;
      this.$store.dispatch("getProjectDetails", [
        this.$route.params.id,
        "client-view",
      ]);
    },
    editItem() {
      this.loading = true;
      localStorage.setItem(
        "project_id_edit",
        JSON.stringify(this.$route.params.id)
      );
      this.$store.dispatch("indexDataAndRout", [
        "project-info",
        this.$route.params.id,
        "/create-project-edit",
      ]);
    },
    async changeProjectStatusToPause() {
      var popUpMsg = confirm("Are you sure you want to pause this project?");
      if (popUpMsg) {
        const { data } = await api.changeDataStatus(
          this.auth.token,
          this.$route.params.id,
          "project-pause-resume"
        );
        if (!data.error) {
          await this.fetchProjectDetails();
          this.color = "success";
          this.msg = "Updated Successfully";
          this.snackbar = true;
        }
      }
    },
    async changeProjectStatusToLive() {
      var popUpMsg = confirm("Are you sure you want to live this project?");
      if (popUpMsg) {
        const { data } = await api.changeDataStatus(
          this.auth.token,
          this.$route.params.id,
          "project-pause-resume"
        );
        if (!data.error) {
          await this.fetchProjectDetails();
          this.color = "success";
          this.msg = data.errorMsg;
          this.snackbar = true;
        }
      }
    },
    // getResponse() {
    //   // this.loading = true;
    //   // this.$store.dispatch("getProjectResponse", [this.$route.params.id, "task"]);
    //   this.$router.push(`/project/${this.$route.params.id}/responses`);
    // },
    goToLive() {
      localStorage.setItem("project_details_by_id", this.$route.params.id);
      localStorage.setItem("projectId", this.$route.params.id);
      router.push("/success-pay");
    },
    expandDate() {
      // console.log(this.indexData);
      this.updateData.end_date = this.projectDetails.end_date;
      this.updateData.project_id = this.projectDetails.id;
      this.dialog = true;
    },
    save(date) {
      if (typeof this.$refs.menu.save === "function") {
        this.$refs.menu.save(date);
      }
      // this.$refs.menu.save(date);
      this.menu = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.budget = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async updateProjectEndingTime() {
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          return axios
            .post(`${ROOT_URL}/${"update-ending-time"}`, this.updateData, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // console.log(response);
              if (response.data.statusCode == 200) {
                this.fetchProjectDetails();
                this.close();
              }
            });
        }
      } catch (error) {
        //   console.log(error);
      }
    },
    async updateProjectToCompleteStatus() {
      var popUpMsg = confirm(
        "Are you sure to change project status to complete!"
      );
      if (popUpMsg) {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            return axios
              .get(`${ROOT_URL}/${"update-status"}/${this.$route.params.id}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                // console.log(response);
                if (response.data.statusCode == 200) {
                  this.fetchProjectDetails();
                }
              });
          }
        } catch (error) {
          // console.log(error);
        }
      }
    },
    openAddBudgetDialog() {
      this.selectedProject = this.projectDetails;
      this.addBudgetDialog = true;
    },
    async addBudget() {
      this.addBudgetLoading = true;
      try {
        const { data } = await api.storeData(
          window.localStorage.getItem("datadash_token"),
          "add-budget",
          {
            project_id: this.selectedProject.id,
            number_of_response: this.noOfResponses,
          }
        );
        if (data.error) {
          if (data.statusCode == 403) {
            this.addBudgetErrorDialog = true;
          }
        } else {
          await this.fetchProjectDetails();
          this.msg = "Added successfully";
          this.color = "success";
          this.snackbar = true;
        }
        this.addBudgetLoading = false;
      } catch (e) {
        //
      }
      this.addBudgetDialog = false;
    },
    responseAnalytics() {
      this.$router.push(`/project/${this.$route.params.id}/response-analytics`);
    },
  },
};
</script>
<style scoped>
.w-165 {
  width: 165px;
  height: 28px;
  margin: 0 0 12px;
}
.actions {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
</style>
